import type { ProductHit } from '@libs/algolia';
import { getProductUrl, hasProductPersonalization } from '@libs/algolia';
import type { RelatedProductItem } from '@libs/common-types';

export const normalizeRecommendedProducts = (products: ProductHit[]): RelatedProductItem[] =>
    products.map(product => ({
        sku: product.objectID ?? String(product.id),
        name: product.name ?? '',
        short_description: product.short_description,
        image: product.images?.small ?? '',
        url: getProductUrl(product, true),
        brand: product.brand,
        bvAverageRating: product.bvAverageRating,
        bvReviewCount: product.bvReviewCount,
        price: {
            number: product.price?.number ?? 0,
            'strikethrough-number': product.price?.['strikethrough-number'],
            validUntil: product.price?.validUntil,
            displayType: product.price?.displayType,
            formatted: {
                primary: product.price?.formatted?.primary ?? '',
                strikethrough: product.price?.formatted?.strikethrough,
            },
        },
        variationData: product.variationData,
        variations: product.variations,
        masterProductID: product.masterProductID,
        merchandisingHierarchy: product.merchandisingHierarchy,
        size: product.size ? Object.values(product.size).join(' ') : undefined,
        color: product.color?.value,
        flavor: product.flavor?.displays,
        category: product.primary_category_name,
        pharmacyType: product['pharmacy-type'],
        isPersonalized: hasProductPersonalization(product.personalization),
        isLivePet: product.isLivePet,
    }));
